module.exports = __webpack_public_path__ + "media/images/checkout/challenger/unit_5x5-061b95d6429ff69c4c5264481c13b52e.png";